/**
 * Read a File/Blob and return its base64 payload (no `data:…;base64,` prefix),
 * the shape AdminDataService.uploadAirlineLogo expects in `fileBase64`.
 * @param {File|Blob} file
 * @returns {Promise<string>}
 */
export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result || '';
      const comma = result.indexOf(',');
      resolve(comma >= 0 ? result.substring(comma + 1) : result);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export default fileToBase64;
